import { IbePriceModelCode, PremiumCabinCategoryID } from '@gecko-akh/pkg-cruise-api-types/src/iris'
import { CabinMainCategoryToCabinType } from './classes'
import { IDuration, IFlexFlightAirlines, IPerson } from './interfaces'

/* eslint-disable no-bitwise */

export const COMFORTAI = 'COMAI'
export const INDAI = 'INDAI'
export const IND = 'IND'
export const CLASSICAI = 'CLAAI'
export const CLASSIC = 'CLA'
export const LIGHT = 'LIG'
export const PAUSCHAL = 'PAU'
export const PAUSCHALAI = 'PAUAI'

export const PRICE_MODEL_SORT_ORDER: IbePriceModelCode[] = [
  COMFORTAI,
  INDAI,
  IND,
  CLASSICAI,
  CLASSIC,
  LIGHT,
  PAUSCHALAI,
  PAUSCHAL,
]

export const CABIN_TYPE_SORT_ORDER = [
  'Innenkabine',
  'Meerblickkabine',
  'Balkonkabine',
  'Verandakabine',
  'Balkon-/Verandakabine',
  'Suite',
]
export const CABIN_MAIN_CATEGORY_TO_CABIN_TYPE = new CabinMainCategoryToCabinType()

export const FLIGHT_CLASS_SORT_ORDER = ['Y', 'P', 'C', 'B', 'F']

export const durations: IDuration[] = [
  { key: (1 << 0), label: '1\u20135' },
  { key: (1 << 1), label: '6\u20139' },
  { key: (1 << 2), label: '10\u201313' },
  { key: (1 << 3), label: '14\u201321' },
  { key: (1 << 4), label: '22+' }
]

export const adults: IPerson[] = [
  { key: '0', listDisplay: '0 Erwachsene' },
  { key: '1', listDisplay: '1 Erwachsener' },
  { key: '2', listDisplay: '2 Erwachsene' },
  { key: '3', listDisplay: '3 Erwachsene' },
  { key: '4', listDisplay: '4 Erwachsene' },
  { key: '5', listDisplay: '5 Erwachsene' },
]

export const juveniles: IPerson[] = [
  { key: '0', listDisplay: '0 Jugendliche' },
  { key: '1', listDisplay: '1 Jugendlicher' },
  { key: '2', listDisplay: '2 Jugendliche' },
  { key: '3', listDisplay: '3 Jugendliche' },
  { key: '4', listDisplay: '4 Jugendliche' },
  { key: '5', listDisplay: '5 Jugendliche' },
]

export const children: IPerson[] = [
  { key: '0', listDisplay: '0 Kinder' },
  { key: '1', listDisplay: '1 Kind' },
  { key: '2', listDisplay: '2 Kinder' },
  { key: '3', listDisplay: '3 Kinder' },
  { key: '4', listDisplay: '4 Kinder' },
  { key: '5', listDisplay: '5 Kinder' },
]

export const babies: IPerson[] = [
  { key: '0', listDisplay: '0 Babys' },
  { key: '1', listDisplay: '1 Baby' },
]

export const flexFlightPriceModels = [
  IND,
  INDAI,
  CLASSIC,
  CLASSICAI,
  COMFORTAI
]

export const flexFlightAirlines: IFlexFlightAirlines[] = [
  { key: 'AF', value: 'Air France' },
  { key: 'LH', value: 'Lufthansa' },
  { key: 'OS', value: 'Austrian Airlines' },
  { key: 'LX', value: 'Swiss' },
  { key: 'SN', value: 'Brussels Airlines' },
  { key: 'EW', value: 'Eurowings' },
  { key: 'DE', value: 'Condor' },
  { key: 'VY', value: 'Vueling' },
  { key: 'KL', value: 'KLM' },
  { key: 'TK', value: 'Turkish Airlines' },
  { key: 'EK', value: 'Emirates' },
  { key: 'QR', value: 'Qatar Airways' },
  { key: 'BA', value: 'British Airways' },
  { key: '4Y', value: 'Eurowings Discover' },
  { key: 'SK', value: 'Scandinavian Airlines' },
  { key: 'AY', value: 'Finnar' },
  { key: 'TG', value: 'Thai Airways International' },
  { key: 'EY', value: 'Etihad Airways' },
  { key: 'XQ', value: 'Sunexpress' },
  { key: 'UA', value: 'United Airlines' },
  { key: 'SQ', value: 'Singapore Airlines' },
  { key: 'DL', value: 'Delta Airlines' },
  { key: 'IB', value: 'Iberia' },
  { key: 'A3', value: 'Aegean Airlines' },
  { key: 'AA', value: 'American Airlines' },
  { key: 'AC', value: 'Air Canada' },
  { key: 'X3', value: 'TUIfly' },
  { key: 'AZ', value: 'ITA Airways' },
  { key: 'U2', value: 'Easyjet' },
  { key: 'FR', value: 'Ryanair' },
  { key: 'TP', value: 'TAP Portugal' },
  { key: 'LG', value: 'Luxair' },
  { key: 'UX', value: 'Air Europa' },
  { key: 'CX', value: 'Cathay Pacific' }
]

export const PremiumCabinCategoryIDs: PremiumCabinCategoryID[] = [
  'IA',
  'IB',
  'MA',
  'MB',
  'MC',
  'MD',
  'CA',
  'BA',
  'BB',
  'VA',
  'VB',
  'VC',
  'VD',
  'VE',
  'VF',
  'VG',
  'VH',
  'DA',
  'DB',
  'DX',
  'DL',
  'BP',
  'BS',
  'VP',
  'VL',
  'SA',
  'SB',
  'SC',
  'SD',
  'SP',
  'SX',
]